<template>
    <div class="recaptcha-block">
        <input type="hidden" name="g-recaptcha-response" :value="gRecaptchaResponse">
        <slot></slot>
    </div>
</template>

<script>
  export default {
    props: {
      siteKey: {
        default: ''
      },

      action: {
        default: ''
      },

      form: {
        default: ''
      },
    },

    mounted() {
      Events.$on('gRecaptchaSubmit', this.getRecaptchaResponse)
    },

    created() {

    },

    data() {
      return {
        gRecaptchaResponse: '',
      }
    },

    methods: {
      getRecaptchaResponse(form) {
        if (this.form != form) {
          return;
        }

        if (grecaptcha) {
          grecaptcha.execute(this.siteKey, {action: this.action}).then((token) => {
            this.gRecaptchaResponse = token;
            Vue.nextTick(()=> {
              document.getElementById(form).submit();
            });
          });
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/frontend/components/RecaptchaV3.vue